import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CACHE_LIFETIME } from '../constant/constants.service';

@Injectable({
	providedIn: 'root'
})
export class CacheService {
	private request: any = {};

	cacheRequest(requestUrl: string, response: HttpResponse<any>): void {
		this.request[requestUrl] = { response, time: new Date().getTime() };
	}

	getCache(requestUrl: string): HttpResponse<any> | null {
		for (const reqUrl in this.request) {
			// on supprime tout ce qui est dans le cache depuis plus de X min
			if (
				new Date().getTime() - this.request[reqUrl]?.time >
				CACHE_LIFETIME * 60 * 1000
			) {
				this.invalidateCache(reqUrl);
			}
		}
		return this.request[requestUrl]?.response;
	}

	invalidateCache(requestUrl: string): void {
		this.request[requestUrl] = null;
	}

	clearCache(): void {
		this.request = {};
	}
}
